<template>
  <div class="new-house">
    <div class="nav-search-box">
      <div class="nav-search">
        <project-search ref="projectSearch" fromPage="newHouse" @getProjectList="getProjectListBySearch" />
      </div>
    </div>
    <div class="house-con-box">
      <div class="house-con">
        <div class="house-screen">
          <div class="screen-item">
            <div class="screen-tit">位置</div>
            <div class="screen-list">
              <div
                v-for="(item, index) in areaList"
                :key="index"
                :class="['screen-li',{active: item.checked}]"
                @click="selectArea(index)"
              >
                {{item.name}}
              </div>
            </div>
          </div>
          <div class="line"></div>
          <!-- 均价 -->
          <div class="screen-item">
            <div class="screen-tit one">均价</div>
            <div class="screen-list">
              <div
                v-for="(item, index) in averagePriceList"
                :key="index"
                :class="['screen-li', 'one', {active: item.checked}]"
                @click="selectAveragePrice(index)"
              >
                {{item.priceName}}
              </div>
            </div>
          </div>
          <!-- 总价 -->
          <div class="screen-item">
            <div class="screen-tit one">总价</div>
            <div class="screen-list">
              <div
                v-for="(item, index) in totalPriceList"
                :key="index"
                :class="['screen-li', 'one', {active: item.checked}]"
                @click="selectTotalPrice(index)"
              >
                {{item.priceName}}
              </div>
            </div>
          </div>
          <!-- 户型 -->
          <div class="screen-item">
            <div class="screen-tit one">户型</div>
            <div class="screen-list">
              <div
                v-for="(item, index) in houseTypeList"
                :key="index"
                :class="['screen-li', 'one', {active: item.checked}]"
                @click="selectHouseType(index)"
              >
                {{item.label}}
              </div>
            </div>
          </div>
          <div class="screen-select" v-if="selectList.length > 0">
            <div class="select-tit">已选条件：</div>
            <el-tag
              v-for="tag in selectList"
              :key="tag.name"
              @close="selectClose(tag)"
              closable
              type="warning">
              {{tag.label}}
            </el-tag>
            <div class="select-clear" @click="selectClear"><i class="el-icon-delete"></i>清空条件</div>
          </div>
        </div>
        <div class="house-list">
          <div class="list-tit">
            <div class="tit-text">已为您找到
              <span class="num">{{projectTotal}}</span>
            个楼盘</div>
            <div class="list-tab">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="默认排序" name="first"/>
                <el-tab-pane label="均价" name="second">
                  <span slot="label">均价
                    <i :class="['el-icon-sort-down',{active: sortType === '2'}]"></i>
                    <i :class="['el-icon-sort-up',{active: sortType === '1'}]"></i>
                  </span>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="project-list" v-if="projectTotal>0">
            <div class="project-item" v-for="(projectItem, index) in projectList" :key="index">
              <project-card :cityId="cityId" :project-info="projectItem"/>
            </div>
          </div>
          <!-- <div class="no-empty" v-else>
            <el-empty description="很抱歉，没有找到与您条件相符的房源"></el-empty>
          </div> -->
          <div v-else class="item-empty-headline">
          <img alt="很抱歉，没有找到与您条件相符的房源" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
          <div class="item-empty-title">很抱歉，没有找到与您条件相符的房源</div>
          </div>


        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 30]"
          background
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next"
          :total="projectTotal"
        >
        </el-pagination>
      </div>
    </div>

  </div>

</template>

<script>
import ProjectSearch from "@/components/ProjectSearch.vue"
import ProjectCard from "./components/ProjectCard.vue"
import { mapGetters } from 'vuex'
import swTracker from '@/mixins/tracker.js'

export default {
  name: "NewHouse",
  mixins: [swTracker],
  components: { ProjectSearch, ProjectCard },
  data () {
    return {
      areaList: [],
      averagePriceList: [
        {priceName:'不限',priceId:{"min":0,"max":1000000},checked:true},
        {priceName:'2万以下',priceId:{"min":0,"max":20000},checked:false},
        {priceName:'2-3万',priceId:{"min":20000,"max":30000},checked:false},
        {priceName:'3-4万',priceId:{"min":30000,"max":40000},checked:false},
        {priceName:'4-5万',priceId:{"min":40000,"max":50000},checked:false},
        {priceName:'5-7万',priceId:{"min":50000,"max":70000},checked:false},
        {priceName:'7-10万',priceId:{"min":70000,"max":100000},checked:false},
        {priceName:'10万以上',priceId:{"min":100000,"max":1000000},checked:false},
      ],
      totalPriceList: [
        {priceName:'不限',priceId:{"min":0,"max":10000},checked:true},
        {priceName:'100万以下',priceId:{"min":0,"max":100},checked:false},
        {priceName:'100-150万',priceId:{"min":100,"max":150},checked:false},
        {priceName:'150-200万',priceId:{"min":150,"max":200},checked:false},
        {priceName:'200-300万',priceId:{"min":200,"max":300},checked:false},
        {priceName:'300-500万',priceId:{"min":300,"max":500},checked:false},
        {priceName:'500-1000万',priceId:{"min":500,"max":1000},checked:false},
        {priceName:'1000万以上',priceId:{"min":1000,"max":10000},checked:false},
      ],
      houseTypeList: [
        {label: '不限',checked:true},
        {label: '一室',checked:false},
        {label: '二室',checked:false},
        {label: '三室',checked:false},
        {label: '四室',checked:false},
        {label: '五室及以上',checked:false}
      ],
      selectTags: [
        { name: '标签一', type: '' },
        { name: '标签二', type: 'success' },
        { name: '标签三', type: 'info' },
        { name: '标签四', type: 'warning' },
        { name: '标签五', type: 'danger' }
      ],
      activeName: 'first',
      displayPriceType: '2', // 1 单价 2 总价
      sortType: '', // ''默认排序；1从低到高；2从高到低
      selectList: [], // 筛选条件
      projectList: [],
      projectData: [],
      projectTotal: 0,
      currentPage: 1,
      pagesize: 5,
    }
  },
  computed: {
    ...mapGetters([
      'homePage',
      'cityId'
    ]),
  },
  beforeRouteLeave (to, from, next) {
    next(() => {
      // setTimeout(() => {
      //   swTrackerReport('mp_pagehide', this.$route.path, this.$route.name, this.$route.query)
      // }, 800)
    })
  },
  watch: {
    'homePage.id' () {
      this.getProjectList()
      this.selectClear()
    },
    'cityId' () {
      this.getAreaListZH()
    },
    '$route.query.searchValue' (val) {
      this.selectList = []
      if (val !== '' && val !== undefined) {
        this.selectList.push({ name: 'projectName', label:val, value:val})
      }
      this.getProjectList()
    }
  },
  created() {
    const searchValue = this.$route.query.searchValue
    this.selectList = []
    if (searchValue !== '' && searchValue !== undefined) {
      this.selectList.push({ name: 'projectName', label:searchValue, value:searchValue})
    }
    if (this.homePage.id) {
      this.getProjectList()
    }
    if (this.cityId) {
      this.getAreaListZH()
    }
  },
  mounted(){
    window.scrollTo(0,0);
  },
  methods: {
    getProjectListBySearch (data) {
      const projectNameItem = this.selectList.find(item => item.name === 'projectName')
      const projectNameIndex = this.selectList.findIndex(item => item.name === 'projectName')
      if (projectNameItem) {
        if (!data.searchValue) {
          this.selectList.splice(projectNameIndex, 1)
        } else {
          projectNameItem.value = data.searchValue
          projectNameItem.label = data.searchValue
        }
      } else {
        this.selectList.push({name: 'projectName', value: data.searchValue, label: data.searchValue})
      }
      this.getProjectList()
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.pageList();
    },
    handleCurrentChange(val) {
      this.currentPage= val
      this.pageList();
    },
    pageList() {
      this.projectTotal = this.projectData.length;
      this.projectList = this.projectData.filter(
        (item, index) =>
          index < this.currentPage * this.pagesize &&
          index >= this.pagesize * (this.currentPage - 1)
      );

    },
    // 根据城市获取区域数据列表
    getAreaListZH(){
      this.areaList = [ {name:'不限', id:'', checked: true} ]
      const params = {
        parentId: this.cityId,
        groupCode: 'zhjt',
      }
      this.$api.getAreaListZH(params).then(res => {
        const areaList = res.data || []
        areaList.forEach(item => {
          if (item.projectCount > 0) {
            item.checked = false
            this.areaList.push(item)
          }
        })
      })
    },
    // 获取项目列表
    getProjectList(){
      let projectName = ''
      let districtIdList = []
      let priceRanges = []
      let roomStructure = []
      this.selectList.forEach(item => {
        if(item.name === 'projectName'){
          projectName = item.value
        }
        if(item.name === 'districtIdList'){
          districtIdList = [item.value]
        }
        if(item.name === 'priceRanges'){
          priceRanges = [item.value]
        }
        if(item.name === 'roomStructure'){
          roomStructure = [item.value]
        }
      })
      const baseParams = {
        projectName,
        districtIdList,
        roomStructure,
        priceRanges,
        displayPriceType: this.displayPriceType,
        sortType: this.sortType,
        homePageId: this.homePage.id,
      }
      const params = { queryString: JSON.stringify(baseParams)}
      this.$api.getProjectList(params).then(res => {
        this.projectData = res.data || []
        this.pageList();
        this.projectTotal = this.projectData.length
      })
    },
    handleClick(tab) {
      const index = tab.index
      let sortType = ''
      if (index === '0') {
        sortType = ''
      }
      if (index === '1') {
        if (this.sortType === '' || this.sortType === '2') {
          sortType ='1'
        }
        if (this.sortType === '1') {
          sortType ='2'
        }
      }
      this.sortType = sortType
      this.getProjectList()
    },
    // 清空条件
    selectClear(){
      this.handleCurrentChange(1)
      this.$refs.projectSearch.searchValue = ''
      this.selectList = [];
      this.getProjectList()
      this.areaList.forEach(item => {
        item.checked = false
        if(item.name==="不限"){
          item.checked = true
        }
      })
      this.averagePriceList.forEach(item => {
        item.checked = false
        if(item.priceName==="不限"){
          item.checked = true
        }
      })
      this.totalPriceList.forEach(item => {
        item.checked = false
        if(item.priceName==="不限"){
          item.checked = true
        }
      })
      this.houseTypeList.forEach(item => {
        item.checked = false
        if(item.label==="不限"){
          item.checked = true
        }
      })
      this.$router.push({ path: '/newHouse' })
    },
    // 选择位置
    selectArea(areaIndex){
      this.handleCurrentChange(1)
      this.areaList.forEach(item => {
        item.checked = false
      })
      this.selectList.forEach((selectItem,selectIndex) => {
        if(selectItem.name === 'districtIdList'){
          this.selectList.splice(selectIndex, 1)
        }
      })
      this.areaList[areaIndex].checked = true
      if(this.areaList[areaIndex].name !== '不限'){
        this.selectList.push({ name: 'districtIdList', label: this.areaList[areaIndex].name, value: this.areaList[areaIndex].id})
      }
      this.getProjectList()
    },
    // 选择均价
    selectAveragePrice(pricIndex){
      this.handleCurrentChange(1)
      this.displayPriceType = 1
      this.averagePriceList.forEach(item => {
        item.checked = false
      })
      this.totalPriceList.forEach(item => {
        item.checked = false
      })
      this.selectList.forEach((selectItem,selectIndex) => {
        if(selectItem.name === 'priceRanges'){
          this.selectList.splice(selectIndex, 1)
        }
      })
      this.averagePriceList[pricIndex].checked = true
      if(this.averagePriceList[pricIndex].priceName !== '不限'){
        this.selectList.push({ name: 'priceRanges', label: this.averagePriceList[pricIndex].priceName, value: this.averagePriceList[pricIndex].priceId})
      }
      this.getProjectList()
    },
    // 选择总价
    selectTotalPrice(pricIndex){
      this.handleCurrentChange(1)
      this.displayPriceType = 2
      this.averagePriceList.forEach(item => {
        item.checked = false
      })
      this.totalPriceList.forEach(item => {
        item.checked = false
      })
      this.selectList.forEach((selectItem,selectIndex) => {
        if(selectItem.name === 'priceRanges'){
          this.selectList.splice(selectIndex, 1)
        }
      })
      this.totalPriceList[pricIndex].checked = true
      if(this.totalPriceList[pricIndex].priceName !== '不限'){
        this.selectList.push({ name: 'priceRanges', label: this.totalPriceList[pricIndex].priceName, value: this.totalPriceList[pricIndex].priceId})
      }
      this.getProjectList()
    },
    // 选择户型
    selectHouseType(houseTypeIndex){
      this.handleCurrentChange(1)
      this.houseTypeList.forEach(item => {
        item.checked = false
      })
      this.selectList.forEach((selectItem,selectIndex) => {
        if(selectItem.name === 'roomStructure'){
          this.selectList.splice(selectIndex, 1)
        }
      })
      this.houseTypeList[houseTypeIndex].checked = true
      if(this.houseTypeList[houseTypeIndex].label !== '不限'){
        this.selectList.push({ name: 'roomStructure', label: this.houseTypeList[houseTypeIndex].label, value: this.houseTypeList[houseTypeIndex].label})
      }
      this.getProjectList()
    },
    // 关闭已选
    selectClose(tag){
      this.handleCurrentChange(1)
      if (tag.name === 'projectName') this.$refs.projectSearch.searchValue = ''
      this.selectList.splice(this.selectList.indexOf(tag), 1);
      const priceRangesShow = this.getShow('priceRanges')
      const districtIdListShow = this.getShow('districtIdListShow')
      const roomStructureShow  = this.getShow('roomStructure')
      if (!priceRangesShow) {
        this.averagePriceList.forEach(item => {
          item.checked = false
        })
        this.totalPriceList.forEach(item => {
          item.checked = false
        })
        this.totalPriceList[0].checked = true
        this.displayPriceType = 2
      }
      if (!districtIdListShow) {
        this.areaList.forEach(item => {
          item.checked = false
        })
        this.areaList[0].checked = true
      }
      if (!roomStructureShow) {
        this.houseTypeList.forEach(item => {
          item.checked = false
        })
        this.houseTypeList[0].checked = true
      }
      this.getProjectList()
    },
    getShow(name){
      return this.selectList.some(function(item) {
        if (item.name == name) { //item.name == "小百里守约"
          return true;  //返回false
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./newHouse";
</style>
